<template>
  <div>
    <Header
      :language="language"
      @language-change="handleLanguageChange"
    />
    <div :class="isProjectPage ? 'project-page-shell' : ''">
      <component :is="currentView" />
    </div>
    <Footer :language="language" />
  </div>
</template>

<script>
  import Project from './views/Project.vue'
  import ProjectZh from './views/ProjectZh.vue'
  import About from "./views/About"
  import AboutZh from "./views/AboutZh"
  import Header from './components/Header'
  import Footer from "@/components/Footer";
  import CV from "@/views/CV";
  import CVZh from "@/views/CVZh";
  import Media from "@/views/Media";
  import MediaZh from "@/views/MediaZh";
  import Project1 from "@/views/Project1";
  import Project1Zh from "@/views/Project1Zh";
  import Project2 from "@/views/Project2";
  import Project2Zh from "@/views/Project2Zh";
  import Project3 from "@/views/Project3";
  import Project3Zh from "@/views/Project3Zh";
  import Project4 from "@/views/Project4";
  import Project4Zh from "@/views/Project4Zh";
  import Project5 from "@/views/Project5";
  import Project5Zh from "@/views/Project5Zh";
  import Project6 from "@/views/Project6";
  import Project6Zh from "@/views/Project6Zh";
  import Project7 from "@/views/Project7";
  import Project7Zh from "@/views/Project7Zh";
  import Project8 from "@/views/Project8";
  import Project8Zh from "@/views/Project8Zh";
  import Project9 from "@/views/Project9";
  import Project9Zh from "@/views/Project9Zh";
  import Project10 from "@/views/Project10";
  import Project10Zh from "@/views/Project10Zh";
  import Project12 from "@/views/Project12";
  import Project12Zh from "@/views/Project12Zh";
  import Project13 from "@/views/Project13";
  import Project13Zh from "@/views/Project13Zh";
  import Project14 from "@/views/Project14";
  import Project14Zh from "@/views/Project14Zh";
  import Project15 from "@/views/Project15";
  import Project15Zh from "@/views/Project15Zh";
  import Project16 from "@/views/Project16";
  import Project16Zh from "@/views/Project16Zh";
  import Project17 from "@/views/Project17";
  import Project17Zh from "@/views/Project17Zh";
  import Project18 from "@/views/Project18";
  import Project18Zh from "@/views/Project18Zh";
  import Project19 from "@/views/Project19";
  import Project19Zh from "@/views/Project19Zh";
  import NotFound from "@/views/NotFound";
  import NotFoundZh from "@/views/NotFoundZh";
  import { getLanguage, setLanguage } from "@/utils/language";

  const routesEn = {
     '/': Project,
    '/about': About,
      '/cv' :CV,
      '/media':Media,
      '/project1':Project1,
      '/project2':Project2,
      '/project3':Project3,
      '/project4':Project4,
      '/project5':Project5,
      '/project6':Project6,
      '/project7':Project7,
      '/project8':Project8,
      '/project9':Project9,
      '/project10':Project10,
      '/project12':Project12,
      '/project13':Project13,
      '/project14':Project14,
      '/project15':Project15,
      '/project16':Project16,
      '/project17':Project17,
      '/project18':Project18,
      '/project19':Project19,
      '/404': NotFound
  }

  const routesZh = {
    '/': ProjectZh,
    '/about': AboutZh,
    '/cv': CVZh,
    '/media': MediaZh,
    '/project1': Project1Zh,
    '/project2': Project2Zh,
    '/project3': Project3Zh,
    '/project4': Project4Zh,
    '/project5': Project5Zh,
    '/project6': Project6Zh,
    '/project7': Project7Zh,
    '/project8': Project8Zh,
    '/project9': Project9Zh,
    '/project10': Project10Zh,
    '/project12': Project12Zh,
    '/project13': Project13Zh,
    '/project14': Project14Zh,
    '/project15': Project15Zh,
    '/project16': Project16Zh,
    '/project17': Project17Zh,
    '/project18': Project18Zh,
    '/project19': Project19Zh,
    '/404': NotFoundZh
  }

  export default {
    components:{
      Header,
        Footer
    },
    data() {
      return {
        currentPath: window.location.hash,
        language: getLanguage()
      }
    },
    computed: {
      currentView() {
        const path = this.currentPath.slice(1) || '/';
        const currentRoutes = this.language === 'zh' ? routesZh : routesEn;
        return currentRoutes[path] || currentRoutes['/404'];
      },
      isProjectPage() {
        const path = this.currentPath.slice(1) || '/';
        return path.startsWith('/project');
      }
    },
    mounted() {
      window.addEventListener('hashchange', () => {
        this.currentPath = window.location.hash;
      });
    },
    methods: {
      handleLanguageChange(lang) {
        this.language = setLanguage(lang);
      }
    }
  }


</script>

<style>
:root {
  --project-page-max-width: 1320px;
}

.project-page-shell {
  max-width: var(--project-page-max-width);
  margin: 0 auto;
}

</style>
